import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Title from './../Complements/Title';
import SelectForm from '../Complements/SelectForm';
import DateFnsUtils from '@date-io/date-fns';
import "moment/locale/es";
import esLocale from "date-fns/locale/es";
import SearchIcon from '@material-ui/icons/Search';

import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
  } from '@material-ui/pickers';
import { Grid, Button, FormControl, InputLabel, Select, MenuItem, CircularProgress } from '@material-ui/core';
// import MaterialTable from 'material-table';

import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import './style/tableresponsive.css';

import Pagination from '@material-ui/lab/Pagination';
import Alert from '@material-ui/lab/Alert';


class CodeList extends Component {
    state = {
        selectedAccount: this.props.balances[0],
        data: []
    }
    handleSubmit = (val) => {
        // console.log(val)
    }
    componentDidMount() {
        // this.setState({selectedAccount: this.props.balances[0]})
    }

    renderTableMovements = () => {
        const { loading, codespaginate, count, page, onChangePaginationCodes } = this.props
        if (loading) {
            return <CircularProgress />
        } else {
            if (codespaginate.length > 0) {
                return  <div>
                        <Grid item xs={12} md={12} lg = {12}>
                            <Table id='table'>
                                <Thead>
                                    <Tr>
                                        <Th>Fecha</Th>
                                        <Th>Tipo</Th>
                                        <Th>Concepto</Th>
                                        <Th>Monto</Th>
                                        <Th>Saldo</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    { 
                                        
                                        codespaginate.map(row => (
                                            <Tr key={row.Documento}>
                                                <Td>{row.Fecha}</Td>
                                                <Td>{row.Transaccion}</Td>
                                                <Td>{row.Concepto}</Td>
                                                <Td>{row.Valor}</Td>
                                                <Td>{row.Saldo}</Td>
                                            </Tr>
                                        ))
                                        
                                    }
                                    
                                </Tbody>
                            </Table>
                        </Grid>
                            <Pagination 
                                count = { count } 
                                color = "primary" 
                                page = { page }
                                onChange = { onChangePaginationCodes }
                            />
                        </div>
            } else {
                return <Alert severity="info">No se han encontrado movimientos en el mes seleccionado.</Alert>
            }
        }
    }

    render() {
        const { classes, selectCode, dateValue, dateStart,
            dateEnd, handleDateStart, handleDateEnd, findDataRange, balances, findAccountCode } = this.props
        const { selectedAccount } = this.state
        return (
            <div>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={8} lg = {8} sm = {12}>
                        <Title>Detalle de movimientos de la Cuenta </Title>
                    </Grid>
                    <Grid item xs={12} md={4} lg = {4} sm = {12}>
                    <FormControl variant="outlined" style={{maxWidth: '100%'}}>
                        <InputLabel id="demo-simple-select-outlined-label">Seleccione una Cuenta</InputLabel>
                        <Select
                        label="Seleccione una Cuenta"
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        defaultValue={selectedAccount}
                        onChange={(e) => findAccountCode(e.target.value) }
                        >
                            {
                                balances.map(option => {
                                return <MenuItem key={option.Codigo} value={option}>{`${option.Codigo} - ${option.TipoCuentaNombre}`}</MenuItem>
                                })
                            }
                        </Select>
                    </FormControl>
                    </Grid>
                </Grid>
                <SelectForm
                    name = { 'Período' }
                    label = { 'Seleccione período '}
                    // data = { [{ id: '1', name: 'data'}] }
                    classes = { classes }
                    dateValue = { dateValue }
                    onSelected = { (val) => selectCode(val)}
                    onSubmit={ this.handleSubmit }
                ></SelectForm>
                <br></br>
                 <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Grid container justify="center" spacing={3}  alignItems="flex-end">
                            <Grid item md={4} sm={12} xs={12}>
                                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                                    <KeyboardDatePicker
                                        // disableToolbar
                                        // variant="inline"
                                        autoOk
                                        variant="inline"
                                        format="dd/MM/yyyy"
                                        margin="normal"
                                        id="date-start"
                                        label="Fecha de inicio"
                                        value={dateStart}
                                        onChange={handleDateStart}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid item md={4} sm={12} xs={12}>
                                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                                    <KeyboardDatePicker
                                        // disableToolbar
                                        autoOk
                                        variant="inline"
                                        format="dd/MM/yyyy"
                                        margin="normal"
                                        id="date-end"
                                        label="Fecha de fin"
                                        value={dateEnd}
                                        onChange={handleDateEnd}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid item md={4} sm={12} xs={12}>
                                <Button 
                                variant="contained"
                                color="primary"
                                onClick = { findDataRange }
                                style= {{ backgroundColor:'#00a0af'}}
                                endIcon={<SearchIcon/>}
                                >
                                    Buscar
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <br/> <br/>
                <Grid container justify="center" spacing={3}  alignItems="center">
                    {
                        this.renderTableMovements()
                    }
                </Grid>
                <div className={classes.seeMore}>
                </div>
            </div>
        );
    }   
}

CodeList.propTypes = {
    codes: PropTypes.array.isRequired,
    classes: PropTypes.object.isRequired,
    // urlPath: PropTypes.string.isRequired,
};

export default CodeList;

